import { render, staticRenderFns } from "./t-field-customized.vue?vue&type=template&id=40567ae9&"
import script from "./t-field-customized.vue?vue&type=script&lang=js&"
export * from "./t-field-customized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports